module.exports = __webpack_public_path__ + "d3e3cd5b1c5bec7203b97295d2a3100f.svg";